import { ConsultNote } from "../../../../consults-and-matching/ConsultNote/ConsultNote";
import ClinicianTagModal from "../../../../team/ClinicianTagModal";
import ConsentSurveyModal from "../../../../_shared/ConsentSurveyModal";

export function ComponentsWithoutRoutes() {
  return (
    <>
      <ConsultNote />
      <ClinicianTagModal />
      <ConsentSurveyModal />
    </>
  );
}
